module.exports = __webpack_public_path__ + "img/10865_S.76be8ae0.png";